import gsap from 'gsap';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';

export default class Home {
  constructor() {
    document
      .querySelector('#homeScr #playBtn')
      .addEventListener('click', this.hideScreen.bind(this));
  }
  init() {
    this.isVisible = false;
    this.proceeded = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
      case 'hide_home':
        this.hideScreen(data['message']['data']);
        break;
    }
  }
  hideScreen(data) {
    if (!this.isVisible) return;

    // if (data && data['screenKey'] !== 'Home') return false;

    this.isVisible = false;
    // this.introRotateTwn.kill();
    document.querySelector('#homeScr').classList.remove('active2');
    gsap.delayedCall(0.5, () => {
      document.querySelector('#homeScr').classList.remove('active');
    });
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'show_screen',
        data: {
          screenKey: 'Instruction',
        },
      },
    });
    this.events.dispatchEvent({
      type: 'SOUND_EVENTS',
      message: { event_type: 'play_sound', data: { sndKey: 'crowd' } },
    });
  }
  showScreen(data) {
    if (data['screenKey'] !== 'Home') return false;

    this.isVisible = true;
    document.querySelector('#homeScr').classList.add('active');

    gsap.delayedCall(0.5, () => {
      document.querySelector('#homeScr').classList.add('active2');
      document.querySelector('#homeScr .title').classList.add('active');
    });
    gsap.delayedCall(0.2, this.animate.bind(this));
  }
  animate() {
    this.frameDate = {
      value: 1,
    };
    document
      .querySelector('#homeScr .title')
      .classList.remove(`title${this.lastVal}`);
    this.lastVal = 0;
    this.introTwn = gsap.to(this.frameDate, {
      value: 44, // Animates from 10 to 0
      duration: 2, // 10 seconds
      ease: 'none',
      delay: 0,
      onUpdate: function () {
        if (this.lastVal != Math.floor(this.frameDate.value)) {
          document
            .querySelector('#homeScr .title')
            .classList.remove(`title${this.lastVal}`);

          this.lastVal = Math.floor(this.frameDate.value);
          document
            .querySelector('#homeScr .title')
            .classList.add(`title${this.lastVal}`);
        }
      }.bind(this),
      onComplete: () => {
        document.querySelector('#playBtn').classList.add(`active`);
        gsap.delayedCall(0.1, () => {
          // document.querySelector('#playBtn').classList.add(`active`);
        });
        // Global.canSwipe = true;
      },
    });
    // this.introRotateTwn = gsap.to('.kick_icon', {
    //   rotation: 360, // Rotates to 360 degrees
    //   duration: 5,
    //   repeat: -1,
    //   ease: 'none', // Keeps the speed constant
    //   delay: 0,
    // });
  }
}
